import React, { useCallback, useEffect, useState } from "react";

import { confirmAdminUser, getCurrentAdminUserData } from "services";

import { clearLocalKlimVar, setLocalKlimVar, useAdminUserContext, useCancelAsyncOnUnmount, useNavigate, useParams, useToggleNavs } from "utils";

import { Col, MainPage, Row, Spin, Typography } from "components";

import { AccountLogo } from "pages/app/account/components/AccountLogo";

export const ConfirmSignin = () => {
  const [isConfirming, setIsConfirming] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();
  const { token, userId } = useParams();
  const { user, setUser } = useAdminUserContext();

  useToggleNavs(false, false);

  const getUserdata = useCallback(() => {
    getCurrentAdminUserData({
      signal,
    }).then((res) => {
      setUser(res);
    });
  }, [setUser, signal]);

  const tokenComplete = useCallback(
    (token, userId) => {
      confirmAdminUser({
        token: token,
        userId: userId,
        signal,
      })
        .then((res) => {
          setLocalKlimVar("token", res.token);
          getUserdata();
        })
        .finally(() => {
          setIsConfirming(false);
        });
    },
    [signal, getUserdata]
  );

  useEffect(() => {
    if (user && !isConfirming) {
      navigate("/dashboard");
    }
  }, [user, isConfirming]); // eslint-disable-line

  useEffect(() => {
    if (token && userId) {
      clearLocalKlimVar("token");
      setIsConfirming(true);
      tokenComplete(token, userId);
    }
  }, []); // eslint-disable-line

  return (
    <MainPage pageName={"sign-in-up"}>
      <Row className="mini-form">
        <Col>
          <AccountLogo />
          <Row>
            <Col>
              <Typography variant="h1">Admin sign in</Typography>
            </Col>
          </Row>
          <Row justify="space-around" align="middle">
            <Col className="center">
              <Spin size="large" />
            </Col>
          </Row>
        </Col>
      </Row>
    </MainPage>
  );
};
